"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCancellationQuestion = function SvgCancellationQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.333c-2.749 0-4.242.197-5.032.373-.69.154-1.075.738-1.142 1.357a36.06 36.06 0 0 0-.206 4.176c.038 2.567 1.34 4.96 3.54 6.308.488.298.992.574 1.468.776.468.2.947.344 1.372.344.426 0 .904-.144 1.372-.344.476-.202.98-.478 1.468-.776 2.2-1.347 3.502-3.741 3.54-6.308a36.067 36.067 0 0 0-.206-4.177c-.066-.618-.452-1.202-1.141-1.356-.79-.176-2.284-.373-5.033-.373ZM8 3.64c-.566 0-1.13.211-1.56.565l.001-.001c-.435.357-.78.903-.78 1.577a.75.75 0 1 0 1.5 0c0-.13.064-.28.231-.418A.997.997 0 0 1 8 5.14c.596 0 .84.341.84.641a.543.543 0 0 1-.075.312c-.058.094-.178.23-.458.426-.513.359-1.057.851-1.057 1.645a.75.75 0 1 0 1.5 0c0-.019 0-.037.038-.089.053-.07.162-.175.38-.328.361-.253.666-.528.874-.867.22-.355.298-.723.298-1.1 0-1.32-1.123-2.14-2.34-2.14Zm.707 7.732a1 1 0 1 1-1.414-1.414 1 1 0 0 1 1.414 1.414Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCancellationQuestion);
var _default = exports["default"] = Memo;